import React from "react";
import { FormInput } from "@shared/form";
import "./index.scss";

interface UserFormTextInputProps {
  labelTitle: string;
  placeholder: string;
}

/**
 * A text input bound to the surrounding `form.AppField`: its value, change, blur and error line come from the field.
 * It renders the bare `FormInput` (not `field.Input`) because this component sits inside the field's render prop
 * and has to wrap it in its own container div.
 */
const UserFormTextInput: React.FunctionComponent<UserFormTextInputProps> = (props) => {
  const { labelTitle, placeholder } = props;
  return (
    <div className="user-form-input-container">
      <FormInput className="user-form-input" type="text" labelTitle={labelTitle} placeholder={placeholder} />
    </div>
  );
};

export default UserFormTextInput;
